import formactivity from './formactivity';

export default {
  formactivity
}; 